<app-header></app-header>
<header class="slidermain menu-page career-page">
    <img src="assets/img/career-background.jpg" alt="news" class="w-100 h-100">
    <div class="container-fluid">
        <div class="mask-content-v-center career-box text-left text-white"> 
            <div class="row mb-5">
                <div class="col-md-8 career-left-box">
                    <h2 class="">{{ 'career.ca_c1' | translate }}</h2>
                  <hr class="bdr top mb-4">
                  <!-- <p class="mb-4">{{ 'career.ca_c17' | translate }} </p> -->
                  <!-- <h3 class="mt-4 mb-2">{{ 'career.ca_c2' | translate }}</h3>
                  <hr class="bdr top mb-4"> -->
                    <div class="row">
                        <div class="col-md-12 cl-box2 ">

                            <div class="job-list mb-4" *ngFor="let job of jobs; let i = index">
                                <h4 class="mb-3" *ngIf="showLang == 'en'">{{job.titleEng}}</h4>
                                <h4 class="mb-3" *ngIf="showLang == 'ar'">{{job.titleArb}}</h4>
                                <div class="desc" *ngIf="showLang == 'en'" [innerHtml]="job.descriptionEng | limitto:200"></div>
                                <div class="desc" *ngIf="showLang == 'ar'" [innerHtml]="job.descriptionArb | limitto:200"></div>
                                <a class="btn btn-primary" data-toggle="modal" attr.data-target="#iDhere{{i}}"> {{ 'career.read_more' | translate }} </a>
                           
                                <!-- Modal -->
                                <div class="modal fade" attr.id="iDhere{{i}}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                                    aria-hidden="true">
                                    <div class="modal-dialog modal-lg" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="mb-0" *ngIf="showLang == 'en'">{{job.titleEng}}</h5>
                                                <h5 class="mb-0" *ngIf="showLang == 'ar'">{{job.titleArb}}</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div class="modal-body">
                                            <div *ngIf="showLang == 'en'" [innerHtml]="job.descriptionEng"></div>
                                            <div *ngIf="showLang == 'ar'" [innerHtml]="job.descriptionArb"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                 
                    
                </div>
                <div class="col-md-4 career-right-box h-100">
                    <form class="form-line" method="POST"  [formGroup]="formGroup" (ngSubmit)="onSubmit()">
                        <div class="row">
                            <div class="col-md-12">
                            <h3>{{ 'career.ca_c3' | translate }}</h3>
                            <hr class="bdr">
                            </div>
                            <div class="col-xs-12 col-md-12 form-group">
                                <label class="control-label" for="name">{{ 'career.ca_c5' | translate }}</label>
                                <input type="text" class="form-control" id="name" formControlName="name" placeholder="{{ 'career.ca_c6' | translate }}">
                            </div>

                            <div class="col-xs-12 col-md-12 form-group">
                                <label class="control-label" for="number">{{ 'career.ca_c7' | translate }}</label>
                                <input type="tel" class="form-control" id="number" formControlName="number" placeholder="{{ 'career.ca_c8' | translate }}">
                            </div>

                            <div class="col-xs-12 col-md-12 form-group">
                                <label class="control-label" for="email">{{ 'career.ca_c9' | translate }}</label>
                                <input type="email" class="form-control" id="eamil" formControlName="email" placeholder="{{ 'career.ca_c10' | translate }}">
                            </div>
                            <div class="col-xs-12 col-md-12 form-group">
                             <label class="my-1 mr-2" for="inlineFormCustomSelectPref">{{ 'career.ca_c11' | translate }}</label>
                                  <select class="custom-select form-control my-1 mr-sm-2" formControlName="profile" id="inlineFormCustomSelectPref">
                                    <option selected>{{ 'career.ca_c11' | translate }}</option>
                                    <option value="{{ 'career.caopt_c1' | translate }}">{{ 'career.caopt_c1' | translate }}</option>
                                    <option value="{{ 'career.caopt_c2' | translate }}">{{ 'career.caopt_c2' | translate }}</option>
                                    <option value="{{ 'career.caopt_c3' | translate }}">{{ 'career.caopt_c3' | translate }}</option>
                                    <option value="{{ 'career.caopt_c4' | translate }}">{{ 'career.caopt_c4' | translate }}</option>
                                  </select>
                            </div>
                             <div class="col-xs-12 col-md-12 form-group">
                                <label for="exampleFormControlFile1">{{ 'career.ca_c12' | translate }}</label>
                                <input type="file" name="resume" (change)="onFileSelect($event)" class="form-control-file form-control" id="exampleFormControlFile1">
                              </div>
                            <div class="col-xs-12 col-md-12 form-group">
                                <label class="control-label" for="Message">{{ 'career.ca_c13' | translate }}</label>
                                <!-- <textarea class="form-control" id="message" name="message" placeholder="Message" rows="4"></textarea> -->
                                <textarea class="form-control" id="message" formControlName="message" rows="5" placeholder="{{ 'career.ca_c14' | translate }}"></textarea>
                            </div>

                            <div class="col-md-12">
                                <button type="submit" class="btn orderonline snd-msg"> {{ 'career.ca_c15' | translate }} 
                                    <span *ngIf="isLoading"><i class="fas fa-circle-notch fa-spin"></i></span>
                            </button>
                            </div>

                        </div>
                    </form>

                    <p class="text-success" *ngIf="sucessMsg != '' && showLang == 'en' " >{{sucessMsg}}</p>
                    <p class="text-success" *ngIf="sucessMsg_ar != '' && showLang == 'ar' " >{{sucessMsg_ar}}</p>

                    <p class="text-danger" *ngIf="errorMsg != '' && showLang == 'en' " >{{errorMsg}}</p>
                    <p class="text-danger" *ngIf="errorMsg_ar != '' && showLang == 'ar' " >{{errorMsg_ar}}</p>

                </div>
            </div>

        </div>
    </div>
</header>